app.controller("UserIndexController", ["$scope", "Users", "$uibModal", "ConfirmModal", "$stateParams", "$state", "usSpinnerService", "toastr",
    function ($scope, Users, $uibModal, ConfirmModal, $stateParams, $state, usSpinnerService, toastr) {
        $scope.users = [];
        $scope.totalItems = 0;
        $scope.itemsPerPage = 20;
        $scope.query = $stateParams.query;

        loadPage($stateParams.page, function () {
            $scope.currentPage = $stateParams.page;
        });

        function loadPage(page, cb) {
            usSpinnerService.spin("root");
            cb = cb || function () {
                };
            Users.list({page: page, limit: $scope.itemsPerPage, query: $stateParams.query}).then(function (data) {
                $scope.users = data.docs;
                var userList = data.docs;
                for (var i in userList) {
                    if (!userList[i].photo && userList[i].gender == 'male') userList[i].defaultPhoto = "img/male.jpg";
                    if (!userList[i].photo && userList[i].gender == 'female') userList[i].defaultPhoto = "img/female.jpg";
                    else if (!userList[i].photo && !userList[i].gender) userList[i].defaultPhoto = "img/no_image.jpg";
                }
                $scope.totalItems = data.total;
                usSpinnerService.stop("root");
                cb();
            });
        }

        $scope.goToPage = function (page) {
            $state.go(".", {
                query: $scope.query,
                page: page
            });
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        $scope.add = function () {
            $uibModal.open({
                controller: "AddUserController",
                templateUrl: _pb + 'admin/users/add-user.html',
                size: "md"
            }).result
                .then(function(result) {
                    loadPage()
                }, function() {
                });
        };

        $scope.edit = function (user) {
            $uibModal.open({
                controller: "EditUserController",
                templateUrl: _pb + 'admin/users/edit-user.html',
                size: "md",
                resolve: {
                    user: function () {
                        return user;
                    }
                }
            }).result
                .then(function(result) {
                    loadPage()
                }, function() {
                });
        };

        $scope.remove = function (user) {
            ConfirmModal.show({
                title: "მომხმარებლის წაშლა",
                message: "გსურთ მომხმარებლის - " + user.firstName + " " + user.lastName + "ს წაშლა?"
            }).result.then(function () {
                Users.remove(user._id).then(function (result) {
                    toastr.success('', 'მომხმარებელი წარმატებით წაიშალა სიიდან');
                    loadPage($stateParams.currentPage)
                }).catch(function(err) {
                    if (err.status == 400) {
                        toastr.error('', 'მომხმარებელს გააჩნია პროფილი !');
                    }
                });
            });
        };

        $scope.changePhoto = function (user) {
            $uibModal.open({
                controller: "ChangeImageFromAdminController",
                templateUrl: _pb + 'parameters/changeImage.html',
                size: "md",
                resolve: {
                    user: function () {
                        return user;
                    }
                }
            }).result
                .then(function (result) {
                    loadPage($stateParams.currentPage)
                }, function () {

                });
        }
    }
]);